import { useEffect } from "react";

export const SuccessfulPage = ({ modalData, onClose }) => {
  useEffect(() => {
    const timer = setTimeout(onClose, 10000);
    return () => clearTimeout(timer);
  }, [onClose]);
  console.log("status:", modalData.status)

  return (
    <section id="subscribe">
      <div className="progress-bar"></div>

      <div className="txt">
        <div className="icon">
          {modalData.status === "success" ? (
            <svg className="svg-icon success" viewBox="0 0 20 20">
              <path
                d="M10.219,1.688c-4.471,0-8.094,3.623-8.094,8.094s3.623,8.094,8.094,8.094s8.094-3.623,8.094-8.094
                         S14.689,1.688,10.219,1.688 M10.219,17.022c-3.994,0-7.242-3.247-7.242-7.241c0-3.994,3.248-7.242,7.242-7.242
                         c3.994,0,7.241,3.248,7.241,7.242C17.46,13.775,14.213,17.022,10.219,17.022 M15.099,7.03c-0.167-0.167-0.438-0.167-0.604,
                         0.002L9.062,12.48l-2.269-2.277c-0.166-0.167-0.437-0.167-0.603,0c-0.166,0.166-0.168,0.437-0.002,0.603l2.573,2.578
                         c0.079,0.08,0.188,0.125,0.3,0.125s0.222-0.045,0.303-0.125l5.736-5.751C15.268,7.466,15.265,7.196,15.099,7.03"
              ></path>
            </svg>
          ) : (
            <svg class="svg-icon err" viewBox="0 0 20 20">
              <path d="M10.185,1.417c-4.741,0-8.583,3.842-8.583,8.583c0,4.74,3.842,8.582,8.583,8.582S18.768,14.74,18.768,10C18.768,5.259,14.926,1.417,10.185,1.417 M10.185,17.68c-4.235,0-7.679-3.445-7.679-7.68c0-4.235,3.444-7.679,7.679-7.679S17.864,5.765,17.864,10C17.864,14.234,14.42,17.68,10.185,17.68 M10.824,10l2.842-2.844c0.178-0.176,0.178-0.46,0-0.637c-0.177-0.178-0.461-0.178-0.637,0l-2.844,2.841L7.341,6.52c-0.176-0.178-0.46-0.178-0.637,0c-0.178,0.176-0.178,0.461,0,0.637L9.546,10l-2.841,2.844c-0.178,0.176-0.178,0.461,0,0.637c0.178,0.178,0.459,0.178,0.637,0l2.844-2.841l2.844,2.841c0.178,0.178,0.459,0.178,0.637,0c0.178-0.176,0.178-0.461,0-0.637L10.824,10z"></path>
            </svg>
          )}
        </div>
        <div className="content">
          <h6
            className={`font-barlow t-t-u f-w-500 p-25 ${
              modalData.status === "success" ? "green" : "red"
            }`}
          >
            {modalData.title}
          </h6>

          <p className="l-h-1-2">
            {/* We&apos;ll review your application and contact you via email or phone
						provided. */}
            {modalData.message}
          </p>
        </div>
      </div>
      <button className="modal-btn" onClick={onClose}>
        Continue
      </button>
    </section>
  );
};
